module.exports = __webpack_public_path__ + "assets/img/3_1217.fd74a41a.jpg";